<template>
  <div id="section11">
    <div class="fondoGrisClaro" >
      <b-container fluid>
        <b-container>
          <br />
          <b-row align-v="center">
            <b-col md="4" sm="12" class="text-center">
              <b-img :src="payImg"/>
            </b-col>
            <b-col md="8" sm="12">
              <br>
              <h2>
                {{$t("payTitulo")}}
              </h2>
              <h3>
                {{$t("payTtl")}}
              </h3>
              <p >
                {{$t("payText")}}
              </p>
              <div>
                <a :href="payUrl" class="btn buttonTurqueza">
                  {{$t("payBtn")}}
                </a>
              </div>
              <br />
            </b-col>
          </b-row>
          <br />
        </b-container>
      </b-container>
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "payTitulo": "Paylands"
    , "payTtl": "Pasarela de pago avanzada PCI-DSS, multilenguaje, multidivisa y accesible desde cualquier dispositivo, con multitud de servicios de valor añadido como Pago One Click, Tokenización, Módulos Woocommerce, Magento y Prestashop, Servicio Anti-Fraude y conexión con TPV para e-commerce y TPV físico, permitiendo una gestión integral de todos los puntos de venta en tiempo real."
    , "payText": " "
    , "payBtn": "MÁS INFORMACIÓN"
  },
  "es":{
    "payTitulo": "Paylands"
    , "payTtl": "Pasarela de pago avanzada PCI-DSS, multilenguaje, multidivisa y accesible desde cualquier dispositivo, con multitud de servicios de valor añadido como Pago One Click, Tokenización, Módulos Woocommerce, Magento y Prestashop, Servicio Anti-Fraude y conexión con TPV para e-commerce y TPV físico, permitiendo una gestión integral de todos los puntos de venta en tiempo real."
    , "payText": " "
    , "payBtn": "MÁS INFORMACIÓN"
  }
}
</i18n>

<script>
export default {
  data() {
    return {
      payImg: require("@/assets/images/pay/partners/paylands.png")
      , payUrl: "#"
    };
  }
};
</script>
